import { Component, HostListener, ViewChild } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from './../../../services/data/data.service';
import { getInstitutionSurveyData } from '../../../services/cuestionarios/cuestionarioV2/query';
import Swal from 'sweetalert2';
import { FormControl, FormGroup, NgModel, Validators } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { environment } from './../../../../environments/environment';
import { HojaRespuestasService } from '../../../services/cuestionarios/cuestionario/hoja-respuestas.service';
import { firstValueFrom } from 'rxjs';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import pdfMake from 'pdfmake/build/pdfmake';
import { ActivatedRoute, Router } from '@angular/router';
import { CuestionarioV2Service, CatalogoPublico } from '../../../services/cuestionarios/cuestionarioV2/cuestionario-v2.service';
import { messages } from '../../funciones/mensajes';
import { RecaptchaComponent } from 'ng-recaptcha';

pdfMake['vfs'] = pdfFonts;

@Component({
  selector: 'app-cuestionariov2',
  templateUrl: './cuestionariov2.component.html',
  styleUrl: './cuestionariov2.component.css'
})
export class Cuestionariov2Component {
private headers = new HttpHeaders();
  public errorMessage = '<br/><br/><div> <span style="text-aling: center;font-size: 10pt;font-weight: 200;">Presione</span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 600;"> esc </span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 200;">para cerrar</span></div>';

  private idAsignacion = 20;
  private asignacion : any = [];
  public dataCuestionario: any = [];
  public dataTarjetas: any = [];
  public hojaRespuesta = []; 
  private pregRequeridas = [];
  public sinContestar = [];
  public bndTerminar = false;
  public incompleto = false;
  public estado = 1; // 1-> formulario 2->responder cuestionario 3-> descripción 4->preguntas 5->terminado 6->asignación cerrada/expirada 7->enlace no válido
  public mensaje = "<b>¡Gracias por tu participación!</b>   Tu opinión es invaluable para nosotros. Agradecemos sinceramente el tiempo que has dedicado a completar esta encuesta, tus respuestas nos ayudarán a mejorar el ambiente de trabajo y a fortalecer nuestro compromiso con tu bienestar y satisfacción.<b>¡Gracias por contribuir a un mejor lugar para todos!</b>"
  public titCmp;
  public selectedRespuesta: any = {};
  public todasLasPreguntas: any[] = [];
  slideIndex = 0;
  // El FormGroup y los campos se construyen dinámicamente según los catálogos
  // que traiga la institución desde el gateway (ver construirFormulario()).
  public info: FormGroup = new FormGroup({});
  public campos: { key: string; label: string; opciones: string[] }[] = [];

  // Orden preferido de los campos demográficos. Un catálogo que no esté aquí
  // igual se muestra (al final), sin tocar código.
  private ordenCatalogos = ['gender', 'age-range', 'seniority-range', 'academic-education-level', 'hierarchy-level'];

  // Catálogos por defecto (fallback si el gateway falla), indexados por catalogKey.
  private catalogosDefault: Record<string, string[]> = {
    'gender': ['Masculino', 'Femenino'],
    'age-range': ['24 años o menos', '25-31 años', '32-40 años', '52 años o más'],
    'seniority-range': ['Menos de 1 año', 'De 1 a 3 años', 'De 4 a 8 años', 'De 9 a 17 años', '18 años o más'],
    'academic-education-level': ['Secundaria o menos', 'Universidad incompleta', 'Técnico o tecnólogo', 'Universidad completa', 'Postgrado'],
    'hierarchy-level': ['Operativo', 'Jefatura', 'Gerencial'],
  };
  public mostrarCatalogo;
  public campoSelec = '';
  private hashRecibido: string = '';
  private cuestionarioId: number = 0;
  // Token de la asignación (query param `a`): desambigua la ronda. Opcional para
  // no romper enlaces viejos (sin él, el back resuelve la asignación abierta).
  private allocationToken: string = '';
  public captchaToken: string | null = null;
  @ViewChild('captchaRef') private captchaRef?: RecaptchaComponent;
  public componenteSeleccionado: any = null;
  public catalogosCargados = false;
  constructor(
    private apollo: Apollo,
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private anonymousService: CuestionarioV2Service,
    private answerSheet: HojaRespuestasService,
    private imageService: HojaRespuestasService,
    private router: Router,
    private cuestionarioService: CuestionarioV2Service,
    private route: ActivatedRoute, 
  ) {
    moment.updateLocale('en',{
      months: [
        "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
        "Septiembre","Octubre","Noviembre","Diciembre"
      ],
      monthsShort: [
        "Ene","Feb","Mar","Abr","May","Jun","Jul","Ago",
        "Sep","Oct","Nov","Dic"
      ]
    });
    localStorage.setItem('sinGuardar','false');
    this.cookieService.set('language', 'es', {path: '/'});
    const language = this.cookieService.get('language');
    this.translate.setDefaultLang(language);
  }
  ngOnInit(){
    this.route.params.subscribe(params => {
      this.hashRecibido = params['hash'] || '';
      this.cuestionarioId = Number(params['id']) || 0;
    });

    this.route.queryParamMap.subscribe(q => {
      const qVal = q.get('q') ?? q.get('qId') ?? q.get('id');
      if (qVal) {
        this.cuestionarioId = Number(qVal);
      }
      this.allocationToken = q.get('a') ?? '';
    });

    this.cargarCatalogos();
    this.getAllocationId()
  }
  public async mensajeSugerencia(txt){
    txt = this.translate.instant(txt);
    messages.infoMessageGraph(txt);
  }
  private async getAllocationId(){
    try{
      const asig = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getInstitutionSurveyData,
          context: { headers: this.headers, },
          variables: {
            access: this.hashRecibido,
            questionnaireId: this.cuestionarioId,
            allocationToken: this.allocationToken || null,
          }
        }).valueChanges.source
      );
      const surveyData = asig.data.getInstitutionSurveyData;
      this.idAsignacion = surveyData.allocationId;
      this.asignacion = {
        idCues: Number(surveyData.questionnaire.id),
      }
      // Los catálogos ya NO se toman de la respuesta del back (venían hardcodeados);
      // se cargan aparte desde el gateway público (ver cargarCatalogos()).
      this.procesarCuestionarioCompleto(surveyData.questionnaire);
    }catch(err){
      const errorMessage = err?.message || err?.toString() || '';
      // La asignación existe pero está cerrada o su fecha ya venció.
      if (errorMessage.includes('La asignación de la institución está cerrada o expiró')) {
        this.estado = 6; // Asignación cerrada / expirada
      // No hay asignación para ese hash/cuestionario/token -> enlace inválido.
      } else if (errorMessage.includes('No se encontró una asignación para la institución')) {
        this.estado = 7; // Enlace no válido (distinto de expirada)
      } else {
        messages.errorMessageGraph(err);
      }
    }
  }

  // Carga los catálogos demográficos desde el gateway público, por institución.
  // Es independiente del cuestionario: si el gateway falla se conservan los
  // catálogos por defecto para no dejar el formulario vacío.
  private async cargarCatalogos() {
    try {
      const catalogs = await firstValueFrom(
        this.cuestionarioService.getSurveyCatalogs(this.hashRecibido)
      );
      this.actualizarCatalogos(catalogs);
    } catch (err) {
      // Fallback: se construye el formulario con los catálogos por defecto
      // para no dejarlo vacío si el gateway falla.
      this.construirFormulario(this.catalogosDefault);
    } finally {
      this.catalogosCargados = true;
    }
  }

  // Convierte la respuesta del gateway ({ [key]: {code, description}[] }) a
  // { [key]: string[] } (ordenado por code) y arma el formulario.
  private actualizarCatalogos(catalogsPorKey: Record<string, CatalogoPublico[]>) {
    const mapeado: Record<string, string[]> = {};
    Object.entries(catalogsPorKey || {}).forEach(([key, items]) => {
      if (Array.isArray(items) && items.length > 0) {
        mapeado[key] = [...items]
          .sort((a, b) => Number(a.code) - Number(b.code))
          .map(i => i.description);
      }
    });
    this.construirFormulario(mapeado);
  }

  // Construye dinámicamente los campos demográficos y el FormGroup a partir de
  // los catálogos que realmente trae la institución. Solo se crea control para
  // los catálogos con elementos: uno ausente ni se muestra, ni bloquea el botón
  // "Continuar", ni viaja en el payload. La etiqueta sale de i18n por catalogKey.
  private construirFormulario(catalogosPorKey: Record<string, string[]>) {
    const keys = Object.keys(catalogosPorKey)
      .filter(k => Array.isArray(catalogosPorKey[k]) && catalogosPorKey[k].length > 0)
      .sort((a, b) => this.indiceOrden(a) - this.indiceOrden(b));

    const group: Record<string, FormControl> = {};
    this.campos = keys.map(key => {
      group[key] = new FormControl('', [Validators.required]);
      return {
        key,
        label: this.translate.instant(`cues.cuestionariov2.catalogos.${key}`),
        opciones: catalogosPorKey[key],
      };
    });
    this.info = new FormGroup(group);
  }

  private indiceOrden(key: string): number {
    const i = this.ordenCatalogos.indexOf(key);
    return i === -1 ? Number.MAX_SAFE_INTEGER : i;
  }


  private procesarCuestionarioCompleto(questionnaireData: any){
    try{
      this.pregRequeridas = [];
      this.dataCuestionario = {
        id: questionnaireData.id,
        name: questionnaireData.name,
        ponderacion: 0,
        elementos: this.ListelementosCategories(questionnaireData.categories, null)
      };
      var peso = 0;
      for(const e of this.dataCuestionario['elementos']){
        peso += e.ponderacion*e.peso/100;
      }
      var aux = JSON.parse(JSON.stringify(questionnaireData.semaphores));
      aux.sort(function(a,b){
        if ( Number(a.value_1) > Number(b.value_1) ) {
          return 1;
        }
        if ( Number(a.value_1) < Number(b.value_1) ) {
          return -1;
        }
        return 0;
      });
      var titN = 1;
      for(const sem of aux){
        var name = this.translate.instant('cues.resultados.titulo-semaforo-'+titN);
        if(name === ('cues.resultados.titulo-semaforo-'+titN)){
          name = '';
        }
        titN++;
      } 


      peso = Number(peso.toFixed(1));
      this.titCmp = this.dataCuestionario.elementos[0].name;
      this.dataCarrusel();
      this.todasLasPreguntas = [];
      for(const c of this.dataCuestionario.elementos){
        // Preguntas directas del componente
        if(c.preguntas && c.preguntas.length > 0) {
          for(const p of c.preguntas){
            this.todasLasPreguntas.push({ 
              ...p, 
              componente: c.name 
            });
          }
        }
        
        // Preguntas de sub-elementos
        if(c.elementos && c.elementos.length > 0) {
          for(const e of c.elementos){
            if(e.preguntas && e.preguntas.length > 0) {
              for(const p of e.preguntas){
                this.todasLasPreguntas.push({ 
                  ...p, 
                  componente: e.name,
                  parentComponente: c.name
                });
              }
            }
          }
        }
      }

    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  private ListelementosCategories(elements, id){
    var elementos = [];
    var cat;
    if(id === null){
      cat = elements.filter( e => e.parent === id);
    }else{
      cat = elements.filter( e => e.parent !== null && e.parent.id === id);
    }

    cat.sort(function(a,b){
      if ( Number(a.id) > Number(b.id) ) {
        return 1;
      }
      if ( Number(a.id) < Number(b.id) ) {
        return -1;
      }
      return 0;
    });

    if(cat.length === 0){
      return [];
    }

    for(const e of cat){
      const quest = this.structureQuestions(e.questions);
      const eleme = this.ListelementosCategories(elements, e.id);
      var peso = 0;
      if(quest.length !== 0){
        for(const q of quest){
          peso += q.ponderacion*q.peso/100;
        }
      }else if(eleme.length !== 0){
        for(const e of eleme){
          peso += e.ponderacion*e.peso/100;
        }
      }
      peso = Number(peso.toFixed(1));
      elementos.push({
        id: e.id,
        name: e.name,
        description: e.description,
        parent: e.parent,
        elementos: eleme,
        preguntas: quest,
        ponderacion: peso,
        peso: e.weighting
      });
    }
    return elementos;
  }

  private structureQuestions(questions){
    var newQuestions = [];

    for(const q of questions){
      var res = [];
      for(const r of q.answers_options){
        res.push({
          id: r.id,
          descrip: r.description,
          score: r.score,
          questionId: q.id
        });
      }
      const answer = this.hojaRespuesta.find(c => c.idPregunta === Number(q.id));
      var valor = 0;
      res.sort(function(a,b){
        if ( Number(a.id) > Number(b.id) ) {
          return 1;
        }
        if ( Number(a.id) < Number(b.id) ) {
          return -1;
        }
        return 0;
      });

      try{
        valor = res.find(c => Number(c.id) === Number(answer.idRespuesta)).score*10/10;
      }catch(err){
      }

      valor = Number(valor.toFixed(1));

      newQuestions.push({
        id: q.id,
        descripcion: {  // Ahora es un objeto
          order: q.order,
          descripcion: q.description,  // La descripción de la pregunta
          requerida: q.required,
          respuestas: res,  // Las opciones de respuesta
          selected: null 
        },
        ponderacion: valor,
        peso: q.weighting
      });
      if(q.required){
        this.pregRequeridas.push({
          id: Number(q.id),
        });
      }
    }
    newQuestions.sort(function(a,b){
      if ( Number(a.order) > Number(b.order) ) {
        return 1;
      }
      if ( Number(a.order) < Number(b.order) ) {
        return -1;
      }
      return 0;
    });

    return newQuestions;
  }
  private dataCarrusel(){
    this.dataTarjetas = [];
    
    for(const c of this.dataCuestionario.elementos){
      // Agregar tarjeta del componente principal
      this.dataTarjetas.push({
        titulo: c.name,
        tipo: 1,
        descripcion: c.description || c.name
      });

      // Verificar si tiene sub-elementos (categorías anidadas)
      if(c.elementos && c.elementos.length > 0) {
        for(const e of c.elementos){
          this.dataTarjetas.push({
            titulo: e.name,
            tipo: 1,
            descripcion: e.description || e.name,
            esSubElemento: true, // Marcar como sub-elemento
            parentName: c.name
          });
          
          if(e.preguntas && e.preguntas.length > 0) {
            for(const p of e.preguntas){
              this.dataTarjetas.push({
                titulo: e.name,
                tipo: 2,
                descripcion: p,
                parentName: c.name
              });
            }
          }
        }
      }

      // Si la categoría principal tiene preguntas directas
      if(c.preguntas && c.preguntas.length > 0) {
        for(const p of c.preguntas){
          this.dataTarjetas.push({
            titulo: c.name,
            tipo: 2,
            descripcion: p
          });
        }
      }
    }
  }

  public async terminar(){
      const result = await messages.confirmationSave(
        this.translate.instant('cues.cuestionariov2.tituloTerminar'),
        this.translate.instant('cues.cuestionariov2.preguntaContinuar'),
        this.translate
      );
      if(result){
        this.sinContestar = [];
        //se valida que todas la preguntas requeridas hayan sido respondidas
        for(const pr of this.pregRequeridas){
          if(!this.hojaRespuesta.find( p => pr['id'] == p.idPregunta)){ //la pregunta requerda no esta en la hoja de respuesta
            this.sinContestar.push(pr);
          }
        }
        this.bndTerminar = this.sinContestar.length == 0 ? true : false;
        
        if(this.bndTerminar){ 
          this.terminarCuestionario();          
        }else{
          this.incompleto = true;
          const componentesFaltantes = [];
          for(const pr of this.sinContestar){
            const pregunta = this.todasLasPreguntas.find(p =>  Number(p.id) === pr.id);
            if(pregunta && pregunta.componente && !componentesFaltantes.includes(pregunta.componente)){
              componentesFaltantes.push(pregunta.componente);
            }
          }
          const mensaje = this.translate.instant('cues.cuestionarios.errorTerminar') + this.sinContestar.length + ' preguntas en: ' + componentesFaltantes.join(', ');
          messages.infoMessageGraph(mensaje);        
        }
      }
    }
  public async terminarCuestionario(){
    // Las keys del payload son los propios catalogKeys; se omiten los vacíos.
    const demographicData: Record<string, string> = {};
    this.campos.forEach(campo => {
      const valor = this.info.controls[campo.key]?.value;
      if (valor) demographicData[campo.key] = valor;
    });

    const answers = (this.hojaRespuesta || []).map(hr => ({
      question_id: Number(hr.idPregunta),
      answerOption_id: Number(hr.idRespuesta)
    }));

    const payload: any = {
      institution_hash: this.hashRecibido || '',
      questionnaireId: this.cuestionarioId || (this.dataCuestionario?.id ?? 0),
      demographicData,
      answers
    };
    // Desambigua la ronda cuando hay dos asignaciones OPEN del mismo hash+cuestionario.
    // Debe ser el mismo token (query param `a`) usado al leer la encuesta.
    // Si el enlace es viejo y no trae `a`, se omite y el back cae al comportamiento anterior.
    if (this.allocationToken) {
      payload.allocationToken = this.allocationToken;
    }
    

    try{
      messages.messageSaving(this.translate.instant('acciones.guardandoRes'),this.translate.instant('acciones.espera'))
      const resp = await firstValueFrom(this.anonymousService.postAnnonymousResponses(payload));
      this.estado = 5;
      Swal.close()
      messages.succesMessageGraph(this.translate.instant('cues.cuestionarios.terminado'))
    }catch(err){
      messages.errorMessageGraph(err);
      return;
    }
    localStorage.setItem('sinGuardar','false');
  }

  //metodo para la construccion de la hoja de respuestas 
  public hojaRespuestas(idPregunta, idRespuesta){
    if(this.hojaRespuesta.find((resp) => resp['idPregunta'] == idPregunta)){ //ya existe una respuesta para esa pregunta y se debe actualizar
      var aux = this.hojaRespuesta.find((resp) => resp['idPregunta'] == idPregunta);
      aux.idRespuesta = Number(idRespuesta);
    }else{ // agregar nueva respuesta
      this.hojaRespuesta.push({idPregunta: Number(idPregunta), idRespuesta: Number(idRespuesta)});
    }
    this.bndTerminar = this.dataTarjetas.every(p => !p.descripcion.requerida || this.hojaRespuesta.some(r => r.idPregunta === p.id));
    localStorage.setItem('sinGuardar','true')
  }
  public sendTo(route: any){
    this.router.navigateByUrl('app/'+route.route);
  }

  public continuar(){
    if(this.info.valid && this.captchaToken){
      return '';
    }else{
      return 'w3-disabled';
    }
  }
  public guardarCampo(item){
    this.info.controls[this.campoSelec].setValue(item);
    this.campoSelec = '';
    this.closeModalP();
  }
  public async guardarInfo() {
    if (!this.captchaToken) {
      messages.errorMessageGraph(this.translate.instant('cues.cuestionariov2.completarCaptcha'));
      return;
    }

    try {
      const resp: any = await firstValueFrom(this.cuestionarioService.verifyCaptcha(this.captchaToken));
      if (!resp.success) {
        this.reiniciarCaptcha();
        messages.errorMessageGraph(this.translate.instant('cues.cuestionariov2.captchaInvalido'));
        return;
      }
    } catch (err) {
      this.reiniciarCaptcha();
      messages.errorMessageGraph(this.translate.instant('cues.cuestionariov2.captchaError'));
      return;
    }
    this.estado = 2;
    setTimeout(() => {
      this.showDivs(this.slideIndex);
    }, 200);
  }

  onCaptchaResolved(token: string) {
    this.captchaToken = token;
  }

  // El token de reCAPTCHA es de un solo uso: si la verificación falla hay que
  // limpiarlo y recargar el widget para forzar un nuevo challenge, si no el
  // botón "Continuar" queda habilitado con un token ya inválido.
  private reiniciarCaptcha() {
    this.captchaToken = null;
    this.captchaRef?.reset();
  }

  plusDivs(n) {
    const newIndex = this.slideIndex + n;
    if (newIndex >= 0 && newIndex < this.dataTarjetas.length) {
        this.slideIndex = newIndex;
    } else if (n === 1 && newIndex >= this.dataTarjetas.length) {
      this.estado = 2;
      this.slideIndex = 0;  // Resetear al inicio
    }
  }
  
  showDivs(n: number) {
    const slides = document.getElementsByClassName("mySlides") as HTMLCollectionOf<HTMLElement>;
    if (slides.length === 0) return; 

    if (n > slides.length) { this.slideIndex = slides.length; }
    if (n < 1) { this.slideIndex = 1; }

    for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none"; // Oculta todas las diapositivas
    }
    slides[this.slideIndex - 1].style.display = "block"; // Muestra la diapositiva actual
  }

  sinResponder(pregunta): string {
    // Verifica si la pregunta es requerida y no tiene respuesta en hojaRespuesta
    const respuesta = this.hojaRespuesta.find((resp) => resp.idPregunta === pregunta.id);
    if (!respuesta && pregunta.requerida && this.incompleto && pregunta.selected === null) {
      return 'borderTest2'; // Clase específica para preguntas sin responder
    }
    return ''; // No aplica clase si la pregunta está respondida
  }
  public openModal(catalogo, campo){
    this.mostrarCatalogo = catalogo;
    this.campoSelec = campo;
    document.getElementById("ampliar")!.style.display = "block";    
  }
  public clickFuera(event, modal) {
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      }, 600);
    }
  }
  public closeModalP(){
    document.getElementById("ampliar")!.style.display = "none";
  }

  public verDescripcionCompleta(componente: any): void {
    this.componenteSeleccionado = componente;
    this.estado = 3; // Cambia al nuevo estado
  }

  public redirigirCuestionario(componente: any): void {
    this.estado = 4;
    // Si el componente tiene sub-elementos, recopilar todas sus preguntas
    if(componente.elementos && componente.elementos.length > 0) {
      this.dataTarjetas = [];
      for(const subElemento of componente.elementos) {
        if(subElemento.preguntas && subElemento.preguntas.length > 0) {
          for(const p of subElemento.preguntas) {
            this.dataTarjetas.push({
              ...p,
              componente: subElemento.name,
              parentComponente: componente.name
            });
          }
        }
      }
    } else {
      // Si no tiene sub-elementos, usar sus preguntas directas
      this.dataTarjetas = (componente.preguntas || []).map(p => ({
        ...p,
        componente: componente.name
      }));
    }
    
    this.titCmp = componente.name;
    this.slideIndex = 0;
    
    // Restaurar respuestas guardadas
    this.dataTarjetas.forEach(p => {
      const resp = this.hojaRespuesta.find(r => r.idPregunta === p.id);
      if (resp) {
        p.descripcion.selected = resp.idRespuesta;
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Enter' && this.estado === 4) {
      const preguntaActual = this.dataTarjetas[this.slideIndex]?.descripcion;
      if(preguntaActual?.selected) this.plusDivs(1);  // Avanza a la siguiente pregunta
    }
  }

  componentesContestados(): number {
    let count = 0;
    for (const comp of this.dataCuestionario.elementos) {
      let preguntas: any[] = [];
      if (comp.preguntas && comp.preguntas.length > 0) preguntas = preguntas.concat(comp.preguntas);
      if (comp.elementos && comp.elementos.length > 0) {
        for (const sub of comp.elementos) {
          if (sub.preguntas && sub.preguntas.length > 0) preguntas = preguntas.concat(sub.preguntas);
        }
      }
      // Filtra solo las requeridas
      const requeridas = preguntas.filter(p => p.descripcion.requerida);
      // Si no tiene requeridas, lo consideramos contestado solo si tiene al menos una pregunta contestada
      if (requeridas.length === 0) {
        if (preguntas.some(p => this.hojaRespuesta.find(r => r.idPregunta == p.id))) count++;
      } else {
        // Solo cuenta como contestado si TODAS las requeridas tienen respuesta
        const todasContestadas = requeridas.every(p =>
          this.hojaRespuesta.find(r => r.idPregunta == p.id && p.descripcion.selected !== null && p.descripcion.selected !== undefined)
        );
        if (todasContestadas) count++;
      }
    }
    return count;
  }

  preguntasContestadas(): number {
    return this.dataTarjetas.filter(p =>
      p.descripcion &&
      p.descripcion.selected !== null &&
      p.descripcion.selected !== undefined
    ).length;
  }
  puedeSeleccionarComponente(index: number): boolean {
    if (index === 0) return true;
    return this.componenteContestadosHasta(index - 1);
  }

  componenteContestadosHasta(index: number): boolean {
    for (let i = 0; i <= index; i++) {
      if (!this.estaComponenteContestado(i)) return false;
    }
    return true;
  }

  puedeAvanzar(): boolean {
    const preguntaActual = this.dataTarjetas[this.slideIndex]?.descripcion;
    if (!preguntaActual) return false;
    // Permite avanzar si: la pregunta tiene respuesta OR la pregunta no es requerida
    return (preguntaActual.selected !== null && preguntaActual.selected !== undefined) || !preguntaActual.requerida;
  }

  estaComponenteContestado(index: number): boolean {
    const comp = this.dataCuestionario.elementos[index];
    let preguntas: any[] = [];
    if (comp.preguntas && comp.preguntas.length > 0) preguntas = preguntas.concat(comp.preguntas);
    if (comp.elementos && comp.elementos.length > 0) {
      for (const sub of comp.elementos) {
        if (sub.preguntas && sub.preguntas.length > 0) preguntas = preguntas.concat(sub.preguntas);
      }
    }
    const requeridas = preguntas.filter(p => p.descripcion.requerida);
    if (requeridas.length === 0) {
      return preguntas.some(p => this.hojaRespuesta.find(r => r.idPregunta == p.id));
    } else {
      return requeridas.every(p =>
        this.hojaRespuesta.find(r => r.idPregunta == p.id && p.descripcion.selected !== null && p.descripcion.selected !== undefined)
      );
    }
  }


}
